// TODO:
export class AggregateError extends Error {
  public readonly errors: Error[];

  public constructor(errors: Error[], message?: string, options?: ErrorOptions) {
    super(message, options);
    this.errors = [ ...errors ];
  }
}

export function isAggregateError(error: Error): error is AggregateError {
  return 'errors' in error && Array.isArray(error.errors);
}
